import { useState } from "react";
import { usePageContext } from "../../../../hooks/context";
import { useApplicationId } from "../../../../hooks/useApplicationId";
import { useFetchClcPackagesQuery } from "../../../../services/clc-application";
import { useClcCompanyApplication } from "../../hooks";
import ClcBasePackageBlock from "./clc-base-package-block";

const ClcPackages = () => {
	const applicationId = useApplicationId();
	const { data: clcPackages } = useFetchClcPackagesQuery(applicationId);
	const { selectedPackage } = usePageContext(useClcCompanyApplication);
	const [optimisticSelectedPackageId, setOptimisticSelectedPackageId] = useState<string>();
	const selectedPackageId = optimisticSelectedPackageId ?? selectedPackage?.packageId;

	const basePackage = clcPackages?.find((pkg) => pkg.packageId === "SVEA-STARTA-BOLAG");
	const foretagarnaPackage = clcPackages?.find(
		(pkg) => pkg.packageId === "FÖRETAGARNA-SVEA-STARTA-BOLAG",
	);

	return (
		<ClcBasePackageBlock
			basePackage={basePackage}
			foretagarnaPackage={foretagarnaPackage}
			selectedPackageId={selectedPackageId}
			onOptimisticSelect={setOptimisticSelectedPackageId}
		/>
	);
};

export default ClcPackages;
